import React from 'react'
import { FormControl, FormErrorMessage, FormLabel, Input } from '@chakra-ui/react'

type UsernameInputProps = {
  register: any;
  errors: any;
}
export const LoginUsernameInput: React.FC<UsernameInputProps> = ({register, errors}) => {
  return (
    <FormControl isRequired isInvalid={!!errors.username}>
      <FormLabel>ユーザーネーム</FormLabel>
      <Input placeholder="blocks-user" type="input" {...register('username')} />
      <FormErrorMessage>{errors.username?.message}</FormErrorMessage>
    </FormControl>
  );
};